import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Albert Charlier, Dirk Rothe, Tobias Schwarzkopf
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : page headers
// =============================================================================
// --- Third-party imports
import React from 'react';
import { Label, Icon, Menu } from 'semantic-ui-react';
// --- Framework imports
import { get } from 'ldash';
import { funcPart } from 'uix/parts';
import { Actions, Sel } from 'uix/registries';
import log from 'uix/logging';
import { QuickSearchInput } from 'uix/modules/search/components';
import { Link, DebugFeature } from 'uix/components';
import { useSelector } from 'uix/hooks';
// --- Globals
const BackendLink = ({})=>{
    let { id, tabname } = useSelector(Sel.request);
    let ancestorAxis = useSelector(Sel.ancestorAxis);
    // obscure rules that will be streamlined
    let nextTabname = tabname == 'viewer' ? 'viewer' : 'id';
    if (ancestorAxis[0]?.datatype == 2) {
        nextTabname = 'wiki';
    }
    return /*#__PURE__*/ _jsx(Link, {
        classname: "tree",
        tabname: nextTabname,
        id: id,
        title: "BACKEND",
        children: /*#__PURE__*/ _jsx(Icon, {
            name: "sitemap",
            style: {
                color: 'black'
            }
        })
    });
};
export const ProtoHeader = funcPart(({ request })=>{
    let { id, tabname } = request;
    return /*#__PURE__*/ _jsxs(Menu, {
        id: "mobileTop",
        borderless: true,
        attached: true,
        children: [
            /*#__PURE__*/ _jsx(Menu.Item, {
                id: "topLogo",
                fitted: true,
                children: /*#__PURE__*/ _jsx(Link, {
                    classname: "proto",
                    tabname: "home",
                    id: null,
                    title: "HOME"
                })
            }),
            /*#__PURE__*/ _jsxs(Menu.Item, {
                position: "right",
                fitted: "vertically",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        name: "search"
                    }),
                    /*#__PURE__*/ _jsx(QuickSearchInput, {
                        width: "100px"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Menu.Item, {
                icon: "bars"
            }),
            /*#__PURE__*/ _jsx(DebugFeature, {
                children: /*#__PURE__*/ _jsx(Menu.Item, {
                    disabled: !id,
                    children: /*#__PURE__*/ _jsx(BackendLink, {})
                })
            })
        ]
    });
});
